import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import Purchases, { Purchases as IPurchasesClass } from "@/lib/purchases";
import { REVENUECAT_APP_PUBLIC_API_KEY } from "@/config/vars";
import { useAppSelector } from "@/hooks/redux";

interface PurchasesContextType {
  purchases: IPurchasesClass | null;
}

const PurchasesContext = createContext<PurchasesContextType | undefined>(undefined);

export const usePurchases = () => {
  const context = useContext(PurchasesContext);
  return context || { purchases: null };
};

export const PurchasesProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAppSelector((state) => state?.auth?.userData);

  const [purchases, setPurchases] = useState<IPurchasesClass | null>(null);

  useEffect(() => {
    async function initializeRevenueCatPurchases() {
      if (user?.organization?.id && !purchases) {
        const instance = Purchases.configure(
          REVENUECAT_APP_PUBLIC_API_KEY,
          `org_${user.organization.id}`,
        );
        setPurchases(instance);
      }
    }
    initializeRevenueCatPurchases();
  }, [user]);

  return <PurchasesContext.Provider value={{ purchases }}>{children}</PurchasesContext.Provider>;
};
